import styled from 'styled-components';

export const MobilePositionUpdateBadgeStyled = styled.div`
    display: inline-block;
    padding: 4px 8px;
    font-weight: 500;
    font-size: 16px;
    background: #8192E41A;
    border-radius: 8px;
    
    &.positive {
        color: var(--color-positive);
    }
    &.negative {
        color: var(--color-negative)
    }
`;

export const MobilePositionUpdateDividerStyled = styled.hr`
    background: var(--color-base-secondary);
    opacity: 1;
`;

export const MobilePositionUpdateOrderProtectionTitleStyled = styled.h5`
    font-size: 14px;
    color: var(--color-white-60);
`;

export const MobilePositionUpdateFixedMenuStyled = styled.div`
    position: fixed;
    padding: 16px;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    box-shadow: 0 0 25px rgb(0 0 0 / 25%);
    background: var(--color-surface);
    z-index: 9;
`;

export const MobilePositionUpdateBottomPlaceholderStyled = styled.div`
    padding-bottom: 134px;
`;

export const MobilePositionUpdateInfoPanelStyled = styled.div`
    display: flex;
    .price {
        min-width: 80px;
        font-weight: 500;
        font-size: 20px;
    }
    .pl {
        font-size: 16px;
        line-height: 2;
    }
`;

export const MobilePositionUpdateChartStyled = styled.div`
    margin-left: -16px;
    margin-right: -16px;
`;
